export const ProgressBar = ({ progressPercentage }) => {
    return (
        <div className=' overflow-hidden rounded-full h-2 w-full bg-gray-100'>
            <div
                style={{ width: `${progressPercentage}%`}}
                className={`h-full bg-primaryy-500`}>
            </div>
        </div>
    );
};